import { useState, useEffect } from "react";
import {
  HeaderComponent,
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  FilterComponent,
  FilterButton,
  EmployeeWithProfile,
  PaginationComponent
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { getAllEducationsReq, deleteEducationReq, getFilterReq } from "./requests";
import { Commons, Const } from "../constants";
import CreateEducation from './components/CreateEducation';
import { message } from "antd";
import UpdateEducation from "./components/UpdateEducation";
import { checkPermissions } from '@comps/commonFunctions';
import moment from "moment";


// ==================================
//   Page Breadcrumbs Start
// ==================================

const langKey = Const["education"].lngKey

const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["education"].route,
      },
    ],
  },
};

// ==================================
//   Page Breadcrumbs End
// ==================================

const IndexEducations = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [filters, setFilters] = useState(props.filters);

  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states
  // ==================================
  //   Use States End
  // ==================================

  // ================================== UpdateLocation
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: "full_name",
      title: trans(`${langKey}.employee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record } />
      },
    },
    {
      key: "institute_name",
      title: trans(`${langKey}.institute_name`),
      dataIndex: "institute_name",
    },
    {
      key: "degree",
      title: trans(`${langKey}.degree`),
      dataIndex: "degree",
    },
    {
      key: "from_date",
      title: trans(`${langKey}.from_date`),
      render: (record) => {
        return record.from_date ? moment(record.from_date).format('YYYY-MM-DD') : ''
      },
    },
    {
      key: "to_date",
      title: trans(`${langKey}.to_date`),
      render: (record) => {
        return record.to_date ? moment(record.to_date).format('YYYY-MM-DD') : ''
      },
    },
    {
      key: "country",
      title: trans(`${langKey}.country`),
      dataIndex: "country",
    },
    {
      key: "city",
      title: trans(`${langKey}.city`),
      dataIndex: "city",
    },

    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onDelete={ onDelete }
          onEdit={ onEdit }
          onView={ onView }
        ></ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllEducationsReq, payload, onSuccess, null);
  };

  const onSuccess = (response) => {
    setPagination(response.employee_educations.meta.pagination);
    setDataSource(response.employee_educations.data);
  };
  const onEdit = (record) => {
    setChildComponent(
      <UpdateEducation onCompleted={ onCompleted } record={ record } disabled={ false } filters={ props.filters } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateEducation onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };

  const onDelete = (record) => {
    makeRequest(setLoader, deleteEducationReq, record.id, onDeleted, onError);
  };
  const onDeleted = (data, res) => {
    onSuccess(data)
    message.success("Education Deleted successfully");
    setDataSource(data.employee_educations.data);
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateEducation onCompleted={ onCompleted } onSuccess={ onSuccess } filters={ props.filters } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };
  //---------------filters-----------------------


  const onOpenFilter = () => {

    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter } moduleName="address"
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }


  //----end filter--------------------
  return (
    <>
      { childComponent }
      <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
        { checkPermissions('profile_employeeEducation') &&
          <>
            <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } /></>
        }
        { props.filters === undefined && <>

          <FilterButton onClick={ onOpenFilter } /> </> }
      </HeaderComponent>
      <BodyComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ !props.filters ? pagination : undefined } setCurrentPage={ setCurrentPage } currentPage={ currentPage } display={ !props.filters } />
    </>
  );
};

export default IndexEducations;

const filterFields = [
  {
    type: "select",
    placeholder: trans(`${langKey}.employee`),
    key: "employments",
    data_key: "supporting_data.employees",
    //is_resource: true
    resource_type: 'employee'
  },
  {
    type: "text",
    placeholder: "Institute Name",
    key: "institute_name",
  },
  {
    type: "text",
    placeholder: "Degree Name",
    key: "degree_name",
  },
  {
    type: "date",
    placeholder: "From",
    key: "from"
  },
  {
    type: "date",
    placeholder: "To",
    key: "to"
  },
]